
import { allProfessions, getProfessionData as getProfessionFromIndex, professionExists as professionExistsInIndex } from "./professions";
import { ProfessionData, RecyclingSolution, WasteMaterial } from "./types/professionTypes";

// Re-export types for backward compatibility
export type { RecyclingSolution, WasteMaterial, ProfessionData };

// Fonction pour récupérer les données d'une profession par son slug
export const getProfessionData = (slug: string): ProfessionData | undefined => {
  return getProfessionFromIndex(slug);
};

// Fonction pour récupérer toutes les professions
export const getAllProfessions = (): ProfessionData[] => {
  return allProfessions;
};

// Fonction pour vérifier si une profession existe
export const professionExists = (slug: string): boolean => {
  return professionExistsInIndex(slug);
};
